/**
 * Typewriter search bar placeholder animation
 * Cycles through popular search queries to engage users and provide inspiration.
 */
document.addEventListener('DOMContentLoaded', () => {
  // Find all standard product search inputs across header, modal, and blocks
  const searchInputs = document.querySelectorAll(
    '.header-search-bar__input, .search-input, .search-page-input'
  );

  if (searchInputs.length === 0) return;

  // Curated list of popular searches for an elegant ethnic wear store
  const phrases = [
    "Search Sarees...",
    "Search Blouses...",
    "Search Wedding Collections...",
   
  ];

  searchInputs.forEach((input) => {
    // Save the original placeholder as the default starting text
    const originalPlaceholder = input.getAttribute('placeholder') || "Search in our store...";
    // Combine original placeholder with custom suggestions to preserve local merchant setting
    const inputPhrases = [
      originalPlaceholder,
      ...phrases.filter(p => p.toLowerCase() !== originalPlaceholder.toLowerCase())
    ];

    let phraseIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    let isFocused = false;
    let timeoutId = null;
    let blinkIntervalId = null;
    let showCursor = true;

    // Helper to clear blinking cursor interval
    function stopBlinking() {
      if (blinkIntervalId) {
        clearInterval(blinkIntervalId);
        blinkIntervalId = null;
      }
    }

    // Pause typing animation while the user is actively focused on the search input
    input.addEventListener('focus', () => {
      isFocused = true;
      stopBlinking();
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      // Revert placeholder to original so user is not distracted while typing
      input.placeholder = originalPlaceholder;
    });

    // Resume typing animation when focus is lost
    input.addEventListener('blur', () => {
      isFocused = false;
      // Start typing loop again
      type();
    });

    function type() {
      // If focused or input has user text, we pause animation updates
      if (isFocused || input.value !== '') {
        stopBlinking();
        timeoutId = setTimeout(type, 1000);
        return;
      }

      const currentPhrase = inputPhrases[phraseIndex];
      stopBlinking(); // Stop blink cycle during active typing/deleting transitions

      if (isDeleting) {
        charIndex--;
      } else {
        charIndex++;
      }

      // Slice current phrase and append the modern sleek cursor '│'
      const currentText = currentPhrase.substring(0, charIndex);
      input.placeholder = currentText + '│';

      // Setting dynamic speed: faster for deleting, slightly varied for natural typing
      let delay = isDeleting ? 40 : 80;

      if (!isDeleting) {
        delay += Math.random() * 40; // Add human-like variation
      }

      if (!isDeleting && charIndex === currentPhrase.length) {
        // Phrase is fully typed: pause and start blinking cursor
        isDeleting = true;
        delay = 2000; // Hold full phrase for 2 seconds

        let blink = true;
        blinkIntervalId = setInterval(() => {
          blink = !blink;
          input.placeholder = currentPhrase + (blink ? '│' : '');
        }, 350);

      } else if (isDeleting && charIndex === 0) {
        // Phrase is fully erased: pause briefly and move to the next phrase
        isDeleting = false;
        phraseIndex = (phraseIndex + 1) % inputPhrases.length;
        delay = 400; // Delay before starting next phrase
        input.placeholder = '│'; // Start next phrase with just the cursor
      }

      timeoutId = setTimeout(type, delay);
    }

    // Initialize typewriter animation for this input
    type();
  });
});
